import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2c93zrgyn5: FaireBrandEntity = {
  token: "b_2c93zrgyn5",
  type: "brand",
  name: "Savor by Suzie",
  avatarUrl:
    "https://cdn.faire.com/fastly/423ef9218205e95479224dd61450cfcffaa7e3ceba9d4c519528455bed49ed79.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c81a0445bc390fe0020dffebf5ba8b198c326e77a75961e504cb74dd84c4e78e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/423ef9218205e95479224dd61450cfcffaa7e3ceba9d4c519528455bed49ed79.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c81a0445bc390fe0020dffebf5ba8b198c326e77a75961e504cb74dd84c4e78e.png",
  location: "Morristown, NJ, USA",
  minimumOrderDollars: 35,
  rating: 4.9,
  reviewCount: 72,
  isTopShop: true,
  isInsider: true,
  description:
    "Did you know pretzels are a symbol of love and good luck?\n\nWhen our youngest daughter was diagnosed with autism and celiac disease, the last thing we felt was luck! Changing the way we ate and giving up SO many of our go-to snacks, including pretzels, was hard. On-top of autism, it was even harder. \n\nThen, we discovered the gut brain connection. Together, we learned how to eat foods that not only tasted good but also made us feel good!\n\nDetermined to find a way back to our favorite snacks— without any gluten, grains, GMO’s, sugar, soy, or dairy — I relentlessly hit the kitchen. Hundreds of botched (but entertaining!) experiments and one serendipitous bakery partnership later, Savor Street No Grainer pretzels were born. \n\nNothing makes us happier than to bring delicious snacks from our family to yours, so you can, “Eat to be your happiest self,” too!\n\nXo Suzie, GF Guru Mama",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:05.475Z",
    importedBy: "entity-db-cli",
  },
};
